import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import s from './NetworkBarItemGroup.scss';
const NetworkBarItemGroup = ({ children, className, icon: Icon, isCollapsed, title, withFolding, hasNewContent, isFolded, biData, onFoldToggle, toggleAriaLabel })=>{
    const toggleId = useUniqueId();
    const foldableId = useUniqueId();
    const foldableRef = useRef(null);
    const [foldableHeight, setFoldableHeight] = useState(0);
    // Set the height using useEffect so we can calc it _after_ this component's children render,
    // otherwise, offsetHeight won't include the rendered show more button in FoldableGroupList.
    // (We include isCollapsed and children to fire this when the menu is first toggled and when new groups load.)
    useEffect(()=>{
        var _foldableRef_current;
        var _foldableRef_current_offsetHeight;
        setFoldableHeight((_foldableRef_current_offsetHeight = (_foldableRef_current = foldableRef.current) === null || _foldableRef_current === void 0 ? void 0 : _foldableRef_current.offsetHeight) !== null && _foldableRef_current_offsetHeight !== void 0 ? _foldableRef_current_offsetHeight : 0);
    }, [
        setFoldableHeight,
        foldableRef,
        isCollapsed,
        children
    ]);
    const shouldConstrainHeight = foldableHeight && withFolding && !isFolded;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isCollapsed && s['collapsed'], isFolded && s['folded'], className)
    }, /*#__PURE__*/ React.createElement(NetworkBarItem, {
        id: toggleId,
        isCollapsed: isCollapsed,
        icon: /*#__PURE__*/ React.createElement(Icon, {
            disableDefaultColors: true,
            size: IconSize.MEDIUM
        }),
        tooltipContent: title,
        showTooltip: isFolded,
        biData: biData,
        onClick: withFolding ? onFoldToggle : undefined,
        hasNewContent: isFolded && hasNewContent,
        "aria-label": toggleAriaLabel,
        "aria-controls": foldableId,
        "aria-expanded": !isFolded
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['label']
    }, title, withFolding && /*#__PURE__*/ React.createElement(React.Fragment, null, ' ', isFolded ? /*#__PURE__*/ React.createElement(ArrowRight, {
        size: IconSize.SMALLER,
        className: s['arrow'],
        disableDefaultColors: true
    }) : /*#__PURE__*/ React.createElement(ArrowDown, {
        size: IconSize.SMALLER,
        className: s['arrow'],
        disableDefaultColors: true
    })))), /*#__PURE__*/ React.createElement("div", {
        className: s['foldable'],
        style: shouldConstrainHeight ? {
            maxHeight: foldableHeight
        } : {},
        id: foldableId,
        "aria-labelledby": toggleId
    }, /*#__PURE__*/ React.createElement("div", {
        ref: foldableRef
    }, children)));
};
NetworkBarItemGroup.displayName = 'NetworkBarItemGroup';
export default NetworkBarItemGroup;

//# sourceMappingURL=NetworkBarItemGroup.js.map